import { useEffect, useState } from "preact/compat";
import useLocalStorageState from "use-local-storage-state";
import { costOfCheckoutItem } from "@/Utils";
import TrashIcon from "@/icons/trash-icon.svg";
import { trackRemoveFromCart } from "@/gtm-analytics";
import { surfsideTrackRemoveFromCart } from "@/shared/surfside-analytics";

function CartItem({ cartItem, onChangeQuantity, onRemoveFromCart, index }) {
	const [quantity, setQuantity] = useState(cartItem.quantity);
	const [retailer, setRetailer] = useLocalStorageState("dutchie_retailer",null);
	const retailerSlug = retailer?.slug;
	const retailerId = retailer?.id;
	const [checkoutId, setCheckoutId] = useLocalStorageState("dutchie_checkout_" + retailerSlug);
	const maxLength = 10; // maximum length of the array
	const arrayFromQuantity = Array.from(
        { length: Math.min(cartItem.product.variants[0].quantity, maxLength) },
        (_, index) => index + 1
    );

	function removeItem(cartItem, index) {
		//remove from cart
		onRemoveFromCart({
			variables: {
				retailerId: retailerId,
				checkoutId: checkoutId,
				itemId: cartItem.id,
			},
		})

		trackRemoveFromCart(cartItem, index);
		surfsideTrackRemoveFromCart(cartItem, index);
	}

	useEffect(() => {
		if (cartItem.quantity) {
			setQuantity(cartItem.quantity);
		}
	}, [cartItem]);
	
	return (
		<div className="sidecart-product">
			<div className="sidecart-product-image">
				<img src={`${cartItem.product.images[0].url}?w=400&h=400`} alt={cartItem.product.name} />
			</div>
			<div className="sidecart-product-content">
				<div className="left">
					<p className="sidecart-product-title">{cartItem.product.name}</p>
					<p className="sidecart-product-brand">
						{cartItem.product.brand?.name}
					</p>
					<div className="sidecart-product-actions">
						<div className="sidecart-product-qty-control">
							<select name="qty" className="qty" value={quantity} onChange={(event) => onChangeQuantity(event.target.value, cartItem)}>
								{arrayFromQuantity.map((item ) => (
									<option key={item} value={item}>{item}</option>
								))}
							</select>
						</div>
						<button
						onClick={() => removeItem(cartItem, index)}
						className="btn-reset btn-remove-from-cart"
						aria-label="Remove From Cart"
						>
							<TrashIcon />
						</button>
					</div>
				</div>
				<div className="right">
					<p className="sidecart-product-price">
						<span>{costOfCheckoutItem(cartItem)}</span>
					</p>
					<span className="sidecart-product-option">{cartItem.option}</span>
				</div>
			</div>
		</div>
	);
}
export default CartItem;